// extracted by mini-css-extract-plugin
export default {"switch":"CustomSwitch_switch__xU2bC"};